var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkaslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.879,
    height: 29.167,
    viewBox: "0 0 118.879 29.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #f07e25;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#15599f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#36b6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#00b0a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.001,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.343,
    y1: 0.053,
    x2: 0.758,
    y2: 1.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fab720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07e25"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9930",
    "data-name": "Group 9930",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    className: "cls-1",
    d: "M334.449,18.064a6.259,6.259,0,0,1,.467,2.368,8.209,8.209,0,0,1-3.552,6.885c-4.611,2.96-10.655,2.368-14.113-1.9a8.607,8.607,0,0,1-1.651-4.86,2.451,2.451,0,0,1,2.368-2.368c4.019,0,.467,6.387,7.228,6.387,3.209,0,5.7-2.119,4.019-5.577a2.48,2.48,0,0,1-.343-1.184,2.34,2.34,0,0,1,1.776-2.243c1.807-.685,3.115,1.184,3.8,2.492M316.1,11.085a6.258,6.258,0,0,1-.467-2.368,8.209,8.209,0,0,1,3.552-6.885c4.611-2.96,10.655-2.368,14.113,1.9a8.682,8.682,0,0,1,1.651,4.985,2.451,2.451,0,0,1-2.368,2.368c-4.019,0-.467-6.387-7.228-6.387-3.209,0-5.7,2.119-4.019,5.577a2.48,2.48,0,0,1,.343,1.184A2.34,2.34,0,0,1,319.9,13.7C318.093,14.294,316.69,12.269,316.1,11.085Zm9.128.841a2.617,2.617,0,1,1-2.617,2.617A2.718,2.718,0,0,1,325.227,11.926Z",
    transform: "translate(-216.069 0.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    className: "cls-2",
    d: "M207.814,29.116a2.262,2.262,0,0,0,1.314.25,3.063,3.063,0,0,0,1.533-.845c.125-.125.125-.25.25-.344L221.146,7.836,226.5,18.288a2.215,2.215,0,0,0,2.128,1.314,2.317,2.317,0,0,0,2.034-1.189,2.231,2.231,0,0,0,0-2.253L223.4,1.64A2.464,2.464,0,0,0,221.271.2a2.428,2.428,0,0,0-2.128,1.44L206.75,25.924a2.64,2.64,0,0,0-.25,1.314,2.457,2.457,0,0,0,1.314,1.878m25.568-4.632A2.378,2.378,0,1,1,231,26.863,2.266,2.266,0,0,1,233.382,24.485Z",
    transform: "translate(-143.458 -0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    className: "cls-3",
    d: "M131.272.166a2.371,2.371,0,0,1,2.372,2.372V7.531a2.372,2.372,0,1,1-4.744,0V2.413A2.348,2.348,0,0,1,131.272.166m0,19.351a2.371,2.371,0,0,1,2.372,2.372v4.994a2.372,2.372,0,1,1-4.744,0V21.889A2.371,2.371,0,0,1,131.272,19.517Zm0-7.116a2.372,2.372,0,1,1-2.372,2.372A2.3,2.3,0,0,1,131.272,12.4Zm5.462-.718a2.336,2.336,0,0,0,3.34,0l7.584-7.491a2.336,2.336,0,0,0,0-3.34,2.336,2.336,0,0,0-3.34,0l-7.584,7.491A2.283,2.283,0,0,0,136.734,11.683Zm0,6.055a2.336,2.336,0,0,1,3.34,0l7.584,7.491a2.361,2.361,0,1,1-3.34,3.34l-7.584-7.491A2.284,2.284,0,0,1,136.734,17.738Z",
    transform: "translate(-92.636 -0.15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9616",
    "data-name": "Group 9616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    className: "cls-4",
    d: "M26.978,0A14.586,14.586,0,0,1,41.585,14.607v.936a2.643,2.643,0,0,1-2.247,1.436,2.586,2.586,0,0,1-2.372-1.654v-.718a9.863,9.863,0,1,0-19.725,0,9.571,9.571,0,0,0,2.5,6.523A2.75,2.75,0,0,1,18.676,24.1a2.7,2.7,0,0,1-2.5.125A14.717,14.717,0,0,1,12.5,14.607,14.4,14.4,0,0,1,26.978,0",
    transform: "translate(-12.494 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7054",
    "data-name": "Path 7054",
    className: "cls-5",
    d: "M27.107,39.507A14.586,14.586,0,0,1,12.5,24.9v-.936a2.842,2.842,0,0,1,2.372-1.311,2.586,2.586,0,0,1,2.372,1.654v.718a9.863,9.863,0,1,0,19.725,0,9.571,9.571,0,0,0-2.5-6.523,2.457,2.457,0,0,1,1.061-2.965,2.209,2.209,0,0,1,2.372-.25,14.546,14.546,0,0,1-10.8,24.22",
    transform: "translate(-12.498 -10.356)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkaslogo);
export default __webpack_public_path__ + "static/media/okaslogo.3c4bd49f1edcb6dace615f021089e439.svg";
export { ForwardRef as ReactComponent };